import React from 'react';
import { Badge, IconButton, Box, Typography, Avatar } from '@mui/material';
import {
  Notifications as NotificationsIcon
} from '@mui/icons-material';
import {
  StyledAppBar,
  HeaderToolbar,
  HeaderTitle,
  SearchAndNotificationContainer
} from './styles';
import { useSidebar } from '../../context/SidebarContext';

import NotificationDrawer from './NotificationDrawer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotifications } from '../../modules/notifications/actions';
import { selectUnreadCount } from '../../modules/notifications/selectors';
import { selectUserProfile } from '../../modules/user/selectors';
import { getUserRoleLabel } from '../../utils/userDisplay';
import { AppDispatch } from '../../store';

const Navbar: React.FC = () => {
  const { activePage, isCollapsed } = useSidebar();
  const dispatch = useDispatch<AppDispatch>();
  const unreadCount = useSelector(selectUnreadCount);
  const { data } = useSelector(selectUserProfile);
  const [notificationAnchorEl, setNotificationAnchorEl] = React.useState<null | HTMLElement>(null);

  React.useEffect(() => {
    dispatch(fetchNotifications({ page: 1, page_size: 10 }));
  }, [dispatch]);

  const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  const getHeaderTitle = () => {
    switch (activePage) {
      case 'worker':
        return 'Worker Agency Management';
      case 'profile':
        return 'Profile Management';
      default:
        return 'TalentHub'; // Default title
    }
  };


  return (
    <StyledAppBar position="fixed">
      <HeaderToolbar disableGutters>
        <HeaderTitle variant="h6" noWrap collapsed={isCollapsed}>
          {getHeaderTitle()}
        </HeaderTitle>

        <SearchAndNotificationContainer>
          <IconButton color="inherit" size="large" onClick={handleNotificationClick}>
            <Badge
              badgeContent={unreadCount}
              color="error"
              invisible={unreadCount === 0}
              overlap="circular"
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
              <NotificationsIcon sx={{ color: theme => theme.palette.grey[600] }} />
            </Badge>
          </IconButton>

          {data && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, ml: 1 }}>
              <Avatar sx={{ bgcolor: '#5E8E7E', width: 36, height: 36, fontSize: '0.9rem', fontWeight: 600 }}>
                {`${data.first_name?.[0] || ''}${data.last_name?.[0] || ''}`.toUpperCase()}
              </Avatar>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: theme => theme.palette.custom.sidebarText, lineHeight: 1.3 }}>
                  {data.first_name} {data.last_name}
                </Typography>
                <Typography variant="caption" sx={{ color: '#888', fontSize: '0.75rem', lineHeight: 1.3 }}>
                  {getUserRoleLabel(data)}
                </Typography>
              </Box>
            </Box>
          )}
        </SearchAndNotificationContainer>
      </HeaderToolbar>
      <NotificationDrawer
        anchorEl={notificationAnchorEl}
        open={Boolean(notificationAnchorEl)}
        onClose={handleNotificationClose}
      />
    </StyledAppBar>
  );
};

export default Navbar;